import { BrowserRouter, Route, Routes } from "react-router-dom";
import Authenticated from "./routes/Authenticated";
import UnAuthenticated from "./routes/UnAuthenticated";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

function App() {

  const { auth, isLoggedIn } = useSelector(state => state.auth);
  const { advisorAuth } = useSelector(state => state.advisorauth.auth);



  const [authenticated, setAuthenticated] = useState(null);

  
  // const params = new URLSearchParams(window.location.search);
  // const dispatch = useDispatch();
  // const requestToken = params.get("request_token");
  // useEffect(() => {
  //   if (requestToken) {
  //     dispatch(postLoginData(requestToken));
  //   }
  // }, [requestToken, dispatch])

  useEffect(() => {
    if (auth || advisorAuth) {

      setAuthenticated(true);
    } else {
      setAuthenticated(false);

    }
  }, [auth, advisorAuth]);


  return (
    <>
      <BrowserRouter>
        <Routes>
          {authenticated ? (
            <Route path="/*" element={<Authenticated authenticated={isLoggedIn || advisorAuth} />} />
          ) : (
            <Route path="/*" element={<UnAuthenticated />} />

          )}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
